import React from 'react';
import LateralMenu from '../LateralMenu';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_deac.png';
import collapsedLogo from '../../../assets/icon_deac.png';
import { faBan, faBuildingShield, faChartPieSimple, faFilePen, faHexagonNodesBolt, faMemoCircleCheck, faSitemap, faTag } from '@fortawesome/pro-regular-svg-icons';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';

export default function DeacLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {
    const items = [];

    if (authenticatedUser?.permissions.deac_manage_dashboard ||
        authenticatedUser?.permissions.deac_manage_acting_body_units_dashboard ||
        authenticatedUser?.permissions.deac_manage_all_acting_bodies_dashboard
    ) {
        items.push({
            icon: faChartPieSimple,
            text: translate('dashboard'),
            action: () => navigation.navigate('Deac', { screen: 'Dashboard' }),
            selected: selectedMenu == 'dashboard'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_acting_body_units_vacancies ||
        authenticatedUser?.permissions.deac_manage_all_acting_bodies_vacancies ||
        authenticatedUser?.permissions.deac_manage_vacancies ||
        authenticatedUser?.permissions.deac_visualize_vacancies
    ) {
        items.push({
            icon: faFilePen,
            text: translate('vacanciesManagement'),
            action: () => navigation.navigate('Deac', { screen: 'Vacancies' }),
            selected: selectedMenu == 'vacancies'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_applications ||
        authenticatedUser?.permissions.deac_manage_acting_body_units_applications ||
        authenticatedUser?.permissions.deac_manage_all_acting_bodies_applications
    ) {
        items.push({
            icon: faMemoCircleCheck,
            text: translate('candidacies'),
            action: () => navigation.navigate('Deac', { screen: 'Applications' }),
            selected: selectedMenu == 'applications'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_acting_body_units_vacancies_templates ||
        authenticatedUser?.permissions.deac_manage_all_acting_bodies_vacancies_templates ||
        authenticatedUser?.permissions.deac_manage_vacancies_templates
    ) {
        items.push({
            icon: faHexagonNodesBolt,
            text: translate('vacanciesTemplates'),
            action: () => navigation.navigate('Deac', { screen: 'VacanciesTemplates' }),
            selected: selectedMenu == 'vacancies-templates'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_presence_control ||
        authenticatedUser?.permissions.deac_manage_acting_body_units_presence_control ||
        authenticatedUser?.permissions.deac_manage_all_acting_bodies_presence_control
    ) {
        items.push({
            icon: faMemoCircleCheck,
            text: translate('presenceControl'),
            action: () => navigation.navigate('Deac', { screen: 'PresenceControl' }),
            selected: selectedMenu == 'presence-control'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_acting_body_vacancy_level ||
        authenticatedUser?.permissions.deac_manage_all_acting_bodies_vacancy_level
    ) {
        items.push({
            icon: faSitemap,
            text: translate('vacancyLevels'),
            action: () => navigation.navigate('Deac', { screen: 'VacancyLevels' }),
            selected: selectedMenu == 'vacancy-levels'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_workplaces ||
        authenticatedUser?.permissions.deac_manage_acting_body_units_workplaces ||
        authenticatedUser?.permissions.deac_manage_all_acting_bodies_workplaces
    ) {
        items.push({
            icon: faBuildingShield,
            text: translate('workplaces'),
            action: () => navigation.navigate('Deac', { screen: 'Workplaces' }),
            selected: selectedMenu == 'workplaces'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_vacancy_tags) {
        items.push({
            icon: faTag,
            text: translate('vacancyTags'),
            action: () => navigation.navigate('Deac', { screen: 'VacancyTags' }),
            selected: selectedMenu == 'vacancy-tags'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_vacancy_cancellation_reasons) {
        items.push({
            icon: faBan,
            text: translate('vacancyCancellationReasons'),
            action: () => navigation.navigate('Deac', { screen: 'VacancyCancellationReasons' }),
            selected: selectedMenu == 'vacancy-cancellation-reasons'
        });
    }

    if (authenticatedUser?.permissions.deac_manage_acting_body_units_reports ||
        authenticatedUser?.permissions.deac_manage_all_acting_bodies_reports
    ) {
        items.push({
            icon: faFolderOpen,
            text: translate('reports'),
            action: () => navigation.navigate('Deac', { screen: 'DeacReports' }),
            selected: selectedMenu == 'reports'
        });
    }

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            setOpen={setOpen}
            items={items}
            open={open}
            authenticatedUser={authenticatedUser}
        />
    );
}
